module.exports = __webpack_public_path__ + "static/img/76c95f072460c4e87805ced1eb54983.5fa40732.png";